/**
 * Contrato del audit_log — backend real, con hash chain (Part 11).
 *
 * Cada entry incluye usuario+gln resueltos por JOIN para mostrar nombres en
 * la UI sin extra requests. `metadata` es JSON libre y depende de la acción.
 */

import { z } from 'zod';

export const AuditUsuarioSchema = z.object({
  id: z.number(),
  username: z.string().nullable(),
  nombre: z.string().nullable(),
});

export const AuditGlnSchema = z.object({
  id: z.number(),
  nombre: z.string().nullable(),
  gln: z.string().nullable(),
});

export const AuditEntrySchema = z.object({
  id: z.number(),
  action: z.string(),
  entityType: z.string().nullable(),
  entityId: z.string().nullable(),
  metadata: z.unknown().nullable(),
  ipAddress: z.string().nullable(),
  userAgent: z.string().nullable(),
  prevHash: z.string().nullable(),
  hash: z.string(),
  createdAt: z.string().nullable(),
  usuario: AuditUsuarioSchema.nullable(),
  gln: AuditGlnSchema.nullable(),
});

export type AuditEntry = z.infer<typeof AuditEntrySchema>;

export const GetAuditEntriesResponseSchema = z.object({
  entries: z.array(AuditEntrySchema),
  limit: z.number(),
  offset: z.number(),
});

export const VerifyChainResponseSchema = z.union([
  z.object({ ok: z.literal(true), total: z.number() }),
  z.object({
    ok: z.literal(false),
    brokenAt: z.number(),
    reason: z.string(),
  }),
]);

export type VerifyChainResponse = z.infer<typeof VerifyChainResponseSchema>;
